<template>
  <div id="app">
    <notifications></notifications>
    <router-view />
  </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'

    export default {
        name: 'App',
        data() {
            return {
                authenticated: false,
            }
        },
        computed: {
          ...mapState("account", ["user"]),
            pageTitle: function() {
                return this.$route.meta.title;
            }
        },
        mounted() {
            const loggedIn = this.$CURRENT_USER.isLogged();

            this.authenticated = (loggedIn) ? true : false;

            if(!this.authenticated && !this.$route.meta.noAuth) {
              //  this.$router.replace({ name: "login" });
            } else {
              this.getCategories()
            }
        },
        methods: {
            ...mapActions({
                clearAlert: 'alert/clear'
            }),
            ...mapActions("events", [
              "getCategories",
            ]),
        },
        watch: {
            $route (to, from){
                // clear alert on location change
                this.clearAlert();
                document.title = to.meta.title || this.$APP_CONFIG.APP_TITLE;
            }
        },
        created () {
            document.title = this.$route.meta.title || this.$APP_CONFIG.APP_TITLE;
            window.addEventListener('storage', (e) => {
               if (e.key == 'user' && !e.value) {
                 window.location.reload();
               }
            });
        }
    }
</script>



<!--Start of Tawk.to Script-->
<script type="text/javascript">
var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='https://embed.tawk.to/664b5634981b6c5647728ef2/1hub4hfad';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})();
///End of Tawk.to Script-->






window.fbAsyncInit = function () {
  FB.init({
    appId: "1021595281271254",
    cookie: true,
    xfbml: true,
    version: "v20.0",
  });

  FB.AppEvents.logPageView();
};

(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");
    
</script>


<style>
#app {
  font-family: 'Segoe UI'
}
</style>
